/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountManagerContactResource
 */
export interface AccountManagerContactResource {
    /**
     * 
     * @type {string}
     * @memberof AccountManagerContactResource
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountManagerContactResource
     */
    emailLink?: string;
}

/**
 * Check if a given object implements the AccountManagerContactResource interface.
 */
export function instanceOfAccountManagerContactResource(value: object): value is AccountManagerContactResource {
    return true;
}

export function AccountManagerContactResourceFromJSON(json: any): AccountManagerContactResource {
    return AccountManagerContactResourceFromJSONTyped(json, false);
}

export function AccountManagerContactResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountManagerContactResource {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'emailLink': json['emailLink'] == null ? undefined : json['emailLink'],
    };
}

export function AccountManagerContactResourceToJSON(value?: AccountManagerContactResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'emailLink': value['emailLink'],
    };
}

